import client from './main-client';

export const getLenderDealsApi = (data) => client().get(`/lender-analytics?getLenderDeals=${data.getLenderDeals}`);
